import { DockContext } from '../context';
import { DOCK_THEME_VARIANT } from '../topics';
import { ThemeManager } from './index';

export const prepareThemeVariant = (
  context: DockContext,
  themeManager: ThemeManager,
) => {
  context.register(DOCK_THEME_VARIANT, { retain: true });
  let previousThemeVariant = '';
  context.subscribe(DOCK_THEME_VARIANT, (id) => {
    if (typeof id === 'string') {
      themeManager.setUrlGlobal(previousThemeVariant, false);
      previousThemeVariant = id;
      themeManager.setUrlGlobal(id, true);
    }
  });
};
